import React from 'react';

const PASSWORD_RULES = {
  minLength: 12,
  requireUppercase: true,
  requireLowercase: true,
  requireNumber: true,
  requireSpecial: true
};

const requirements = [
  { label: 'At least 12 characters', test: (p) => p.length >= 12 },
  { label: 'One uppercase letter', test: (p) => /[A-Z]/.test(p) },
  { label: 'One lowercase letter', test: (p) => /[a-z]/.test(p) },
  { label: 'One number', test: (p) => /\d/.test(p) },
  { label: 'One special character', test: (p) => /[!@#$%^&*()_+\-=[\]{}|;:,.<>?]/.test(p) }
];

function getStrength(password) {
  if (!password) return { score: 0, label: '', color: '#2d3748' };
  let score = 0;
  if (password.length >= 8) score++;
  if (password.length >= 12) score++;
  if (password.length >= 16) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[a-z]/.test(password)) score++;
  if (/\d/.test(password)) score++;
  if (/[!@#$%^&*()_+\-=[\]{}|;:,.<>?]/.test(password)) score++;

  if (score <= 2) return { score, label: 'Weak', color: '#ef4444' };
  if (score <= 4) return { score, label: 'Fair', color: '#f59e0b' };
  if (score <= 5) return { score, label: 'Good', color: '#06b6d4' };
  return { score, label: 'Strong', color: '#10b981' };
}

export function validatePasswordFrontend(password) {
  const errors = [];
  if (!password || password.length < PASSWORD_RULES.minLength) {
    errors.push(`Password must be at least ${PASSWORD_RULES.minLength} characters`);
  }
  if (PASSWORD_RULES.requireUppercase && !/[A-Z]/.test(password)) {
    errors.push('One uppercase letter required');
  }
  if (PASSWORD_RULES.requireLowercase && !/[a-z]/.test(password)) {
    errors.push('One lowercase letter required');
  }
  if (PASSWORD_RULES.requireNumber && !/\d/.test(password)) {
    errors.push('One number required');
  }
  if (PASSWORD_RULES.requireSpecial && !/[!@#$%^&*()_+\-=[\]{}|;:,.<>?]/.test(password)) {
    errors.push('One special character required');
  }
  return errors;
}

export default function PasswordStrengthMeter({ password }) {
  const strength = getStrength(password);
  const maxBars = 5;
  const filledBars = Math.min(Math.ceil((strength.score / 7) * maxBars), maxBars);

  return (
    <div className="password-strength-container">
      {password && (
        <>
          <div className="password-strength-bars">
            {Array.from({ length: maxBars }).map((_, i) => (
              <div
                key={i}
                className="password-strength-bar"
                style={{
                  backgroundColor: i < filledBars ? strength.color : '#2d3748'
                }}
              />
            ))}
          </div>
          {strength.label && (
            <span className="password-strength-label" style={{ color: strength.color }}>
              {strength.label}
            </span>
          )}
        </>
      )}
      <ul className="password-requirements">
        {requirements.map((req, i) => {
          const met = password ? req.test(password) : false;
          return (
            <li key={i} className={met ? 'met' : 'unmet'}>
              <span className="req-icon">{met ? '\u2713' : '\u25CB'}</span>
              {req.label}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
